<div class="p-20 fx-row fx-wrap align-items-center justify-content-center text-center">
    <div class="fx-flex-100 align-items-center justify-content-center text-center">
        <span class="title mb-10 text-center">{{'ADD_ORGANIZATION_SUBSCRIPTION.TITLE' | translate}}</span>
    </div>
    <span class="text mt-20">{{'ADD_ORGANIZATION_SUBSCRIPTION.INSTRUCTIONS' | translate}}</span>
    <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-center mt-20">
        <app-select initial="none" label="{{'ORGANIZATION.PLAN' | translate}}" [options]="plans" [multiple]="false"
            [emitOnInit]="false" (change)="onPlanChange($event)" [value]="subscriptionToCreate.plan"
            [labelOutside]="false" class="fx-flex-100" [error]="errors['plan']" [bottomWrapper]="true"></app-select>
        <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-100"
            *ngIf="subscriptionToCreate.plan">
            <div class="fx-flex-100 fx-row justify-content-between align-items-center">
                <span class="text light">{{'ORGANIZATION.PLAN' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text bold main">{{subscriptionToCreate.plan.label}}</span>
            </div>
            <div class="fx-flex-100 fx-row justify-content-between align-items-center">
                <span class="text light">{{'PLAN.TYPE' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{'PLAN.TYPE_'+subscriptionToCreate.plan.type | translate}}</span>
            </div>
            <div class="fx-flex-100 fx-row justify-content-between align-items-center">
                <span class="text light">{{'PLAN.ANNUAL_PRICE' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text bold">{{subscriptionToCreate.plan.annualPrice}} €</span>
            </div>
            <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="subscriptionToCreate.plan.maxVolume">
                <span class="text light">{{'PLAN.MAX_VOLUME' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{subscriptionToCreate.plan.maxVolume}} Go</span>
            </div>
            <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="subscriptionToCreate.plan.maxTrademarks">
                <span class="text light">{{'PLAN.MAX_TRADEMARKS' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{subscriptionToCreate.plan.maxTrademarks}}</span>
            </div>
            <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="subscriptionToCreate.plan.maxCases">
                <span class="text light">{{'PLAN.MAX_CASES' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{subscriptionToCreate.plan.maxCases}}</span>
            </div>
            <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="subscriptionToCreate.plan.maxCrawlerUrl">
                <span class="text light">{{'PLAN.MAX_CRAWLER_URL' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{subscriptionToCreate.plan.maxCrawlerUrl}}</span>
            </div>
        </div>
    </div>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-flex-100 fx-row align-items-end justify-content-center">
        <div class="fx-flex-25 pr-10">
            <app-input [placeholder]="('ORGANIZATION.ADDITIONAL_VOLUME' | translate) + '...'"
                [label]="('ORGANIZATION.ADDITIONAL_VOLUME' | translate)" type="number"
                [(value)]="subscriptionToCreate.additionalVolume" [bottomWrapper]="true"
                [hint]="additionalVolumePrice() ? '+'+additionalVolumePrice()+' €' : undefined"
                class="fx-flex-100"></app-input>
        </div>
        <div class="fx-flex-25 pl-10 pr-10">
            <app-input [placeholder]="('ORGANIZATION.ADDITIONAL_TRADEMARKS' | translate) + '...'"
                [label]="('ORGANIZATION.ADDITIONAL_TRADEMARKS' | translate)" type="number"
                [(value)]="subscriptionToCreate.additionalTrademarks" [bottomWrapper]="true"
                [hint]="additionalTrademarksPrice() ? '+'+additionalTrademarksPrice()+' €' : undefined"
                class="fx-flex-100"></app-input>
        </div>
        <div class="fx-flex-25 pl-10 pr-10">
            <app-input [placeholder]="('ORGANIZATION.ADDITIONAL_CASES' | translate) + '...'"
                [label]="('ORGANIZATION.ADDITIONAL_CASES' | translate)" type="number"
                [(value)]="subscriptionToCreate.additionalCases" [bottomWrapper]="true"
                [hint]="additionalCasesPrice() ? '+'+additionalCasesPrice()+' €' : undefined"
                class="fx-flex-100"></app-input>
        </div>
        <div class="fx-flex-25 pl-10">
            <app-input [placeholder]="('ORGANIZATION.ADDITIONAL_CRAWLER_URL' | translate) + '...'"
                [label]="('ORGANIZATION.ADDITIONAL_CRAWLER_URL' | translate)" type="number"
                [(value)]="subscriptionToCreate.additionalCrawlerUrl" [bottomWrapper]="true"
                class="fx-flex-100"></app-input>
        </div>
    </div>
    <mat-divider class="fx-flex-100 mv-20" *ngIf="subscriptionToCreate && subscriptionToCreate.plan"></mat-divider>
    <div class="fx-flex-100 fx-row align-items-center justify-content-between"
        *ngIf="subscriptionToCreate && subscriptionToCreate.plan">
        <span class="text bold dark">{{'ORGANIZATION.SUBSCRIPTION_PRICE' | translate}}</span>
        <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
        <span class="text bold main">{{subscriptionPrice()}} €</span>
    </div>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row align-items-center justify-content-center fx-flex-100">
        <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
        <button class="main-button fx-flex ml-10" (click)="onSave()" [class.disabled]="_hasErrors()"
            [disabled]="_hasErrors()">{{'ACTIONS.VALIDATE'
            | translate}}</button>
    </div>
</div>